import React, { useState } from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Grid, Card, Divider, CardContent, IconButton, Box } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import moment from "moment";
import StatusBadge from "components/badge/StatusBadge";

const ViewMilestone = (props) => {
    const { open, handleClose, rowData } = props;

    const labelStyle = {
        fontSize: "14px",
        color: "#6b7280",
        display: "flex",
        alignItems: "center",
        gap: "4px",
    };

    const valueStyle = {
        fontSize: "15px",
        color: "#111827",
        fontWeight: 500,
        mt: 0.5,
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                    lineHeight: "100%",
                    color: "#140F36",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    View Milestone Details
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <RxCross2 style={{ fontSize: "30px", color: "#140F36" }} />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Grid container spacing={2}>

                    <Grid size={12}>
                        <Card
                            elevation={0}
                            sx={{
                                borderRadius: "3px",
                                border: "1px solid #e5e7eb",
                                backgroundColor: "#fff",
                                p: 2,
                            }}
                        >
                            {/* Header */}
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    mb: 1,
                                }}
                            >
                                <Typography sx={{ fontWeight: 600, fontSize: "16px" }}>
                                    Milestone Information
                                </Typography>
                            </Box>

                            <Divider sx={{ mb: 2 }} />

                            <CardContent sx={{ pt: 0 }}>
                                <Grid container spacing={2}>

                                    <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                        <Typography sx={labelStyle}>Milestone Name:</Typography>
                                        <Typography sx={valueStyle}>{rowData?.milestone ?? "N/A"}</Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                        <Typography sx={labelStyle}>Completion (Progress %):</Typography>
                                        <Typography sx={valueStyle}>{rowData?.percentageComplete ? rowData?.percentageComplete : "N/A"}</Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                        <Typography sx={labelStyle}>Due Date:</Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.dueDate ? moment.utc(rowData?.dueDate).format("DD MMM YYYY") : "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                        <Typography sx={labelStyle}>Cure Period Due Date:</Typography>
                                        <Typography sx={valueStyle}>
                                            {rowData?.curePeriodDueDate ? moment.utc(rowData?.curePeriodDueDate).format("DD MMM YYYY") : "N/A"}
                                        </Typography>
                                    </Grid>

                                    <Grid size={{ xs: 12, sm: 4, md: 4 }}>
                                        <Typography sx={labelStyle}>Status:</Typography>
                                        <StatusBadge status={rowData?.status} />
                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ViewMilestone;